export const UserAbortedPasskeyCreationError = {
    code: 0,
    name: 'NotAllowedError',
};
